import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-container" }
const _hoisted_2 = ["id"]

import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import TestPayments from "@/builder/components/payment/TestPayments.vue";
import { useRenderStore } from '@/builder/stores/renderStore';
import { MerchantType } from '@/enums';
import { PropType, Ref, computed, inject } from "vue";
import { PageDesign } from '../page/PageInterface';
import AuthNetPaymentComponent from './AuthNetPaymentComponent.vue';
import { IPaymentComponent } from './PaymentInterface';
import PaypalPaymentComponent from './PaypalPaymentComponent.vue';
import StripePaymentComponent from './StripePaymentComponent.vue';

// injects

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentComponent',
  props: {
    component: {
        type: Object as PropType<IPaymentComponent>,
        required: true
    },
    organizationId: {
        type: Number as PropType<number | null>,
        required: true,
        default: null
    },
    merchantAccount: {
        type: String,
        required: true,
    },
    tokenizationKey: {
        type: String,
        required: true,
    },
    readOnly: {
        type: Boolean,
        required: true,
        default: false
    },
    payPalGatewayId: {
        type: Number as PropType<number | null>,
        required: false,
        default: null
    },
    payPalMerchantAccount: {
        type: String as PropType<string | null>,
        required: false,
        default: null
    },
    payPalCurrency: {
        type: String as PropType<string | null>,
        required: false,
        default: null
    },
    merchantType: {
        type: Number as PropType<MerchantType>,
        required: true,
    }
},
  setup(__props) {

const renderStore = useRenderStore();
const pageDesign = inject("pageDesign") as Ref<PageDesign>;

// props
const props = __props;

// computed
const parentStep = computed(() => {
    return renderStore.getFormStep(props.component.id);
});

const formIsOnParentStep = computed(() => {
    return renderStore.step === parentStep.value;
});

const hasPayPal = computed(() => {
    return (
        props.component.customData.enablePayPal &&
        props.payPalMerchantAccount !== null &&
        props.payPalCurrency !== null &&
        props.payPalGatewayId !== null
    );
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(renderStore).isTestMode)
      ? (_openBlock(), _createBlock(TestPayments, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      id: __props.component.id + '_payment-element-form'
    }, [
      (hasPayPal.value)
        ? (_openBlock(), _createBlock(PaypalPaymentComponent, {
            key: 0,
            component: props.component,
            readOnly: props.readOnly,
            payPalGatewayId: props.payPalGatewayId,
            payPalMerchantAccount: props.payPalMerchantAccount,
            payPalCurrency: props.payPalCurrency,
            formIsOnParentStep: formIsOnParentStep.value,
            pageDesign: _unref(pageDesign)
          }, null, 8, ["component", "readOnly", "payPalGatewayId", "payPalMerchantAccount", "payPalCurrency", "formIsOnParentStep", "pageDesign"]))
        : _createCommentVNode("", true),
      (props.merchantType == _unref(MerchantType).StripeUnified)
        ? (_openBlock(), _createBlock(StripePaymentComponent, {
            key: 1,
            component: props.component,
            readOnly: props.readOnly,
            merchantAccount: props.merchantAccount,
            tokenizationKey: props.tokenizationKey,
            formIsOnParentStep: formIsOnParentStep.value,
            pageDesign: _unref(pageDesign),
            organizationId: props.organizationId
          }, null, 8, ["component", "readOnly", "merchantAccount", "tokenizationKey", "formIsOnParentStep", "pageDesign", "organizationId"]))
        : _createCommentVNode("", true),
      (props.merchantType == _unref(MerchantType).AuthorizeNet)
        ? (_openBlock(), _createBlock(AuthNetPaymentComponent, {
            key: 2,
            component: props.component,
            readOnly: props.readOnly,
            merchantAccount: props.merchantAccount,
            tokenizationKey: props.tokenizationKey,
            formIsOnParentStep: formIsOnParentStep.value,
            pageDesign: _unref(pageDesign),
            organizationId: props.organizationId
          }, null, 8, ["component", "readOnly", "merchantAccount", "tokenizationKey", "formIsOnParentStep", "pageDesign", "organizationId"]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(ValidatedInput, {
      id: __props.component.id,
      displayName: 'Payment Method Type',
      value: _unref(renderStore).gift.paymentMethodType,
      isStepError: true,
      name: "PaymentMethodType"
    }, null, 8, ["id", "value"]),
    _createVNode(ValidatedInput, {
      id: __props.component.id,
      displayName: 'Payment Method',
      value: _unref(renderStore).gift.paymentMethodId,
      isRequired: true,
      isStepError: true,
      name: "PaymentMethodId"
    }, null, 8, ["id", "value"])
  ]))
}
}

})